import { Component, OnInit, ViewChild, ElementRef } from '@angular/core';
import { ApiService } from '../api.service';
import { HandlerService } from '../handler.service';
import { Router } from '@angular/router';
import { Platform } from '@angular/cdk/platform';
import { TranslateService } from '@ngx-translate/core';
import { AuthService } from '../auth.service';
import { ExcelService } from '../excel.service';
import { MatTableDataSource } from '@angular/material/table';

@Component({
  selector: 'app-manage-product',
  templateUrl: './manage-product.component.html',
  styleUrls: ['./manage-product.component.scss'],
})
export class ManageProductComponent {
  @ViewChild('map',{static: false}) mapElement: ElementRef;  
  displayedColumns = ['name','code','brand','purchaseCategory','delete'];
  dataSource: any; 
  cardView;
  sort;
  applyFilter(filterValue: string) {
    filterValue = filterValue.trim(); // Remove whitespace
    filterValue = filterValue.toLowerCase(); // MatTableDataSource defaults to lowercase matches
    this.dataSource.filter = filterValue;
    
  } 
  items:any=[];
  loader:boolean=true;
  search:any=[];
  fontStyle;
  editId;
  excelData: any = [];
  category;
  cateName;
  cateId;

  

  constructor(public service:ApiService, 
              public handler:HandlerService,
              public router:Router,
              public platform:Platform,
              public translate: TranslateService,
              private excelService: ExcelService,
              public auth:AuthService) { }

  ionViewWillEnter() {
    this.fontStyle=localStorage.getItem('lang');
    if (this.platform.ANDROID || this.platform.IOS) {
      this.cardView = 'true';
    }
    else{
      if(localStorage.getItem('config')){
        var con = JSON.parse(localStorage.getItem('config'));
        let y = con.find(res => res.shortCdConst == "DFLTCARDLYT");
        if(y){
          this.cardView=y.userValue;
        }
        else{
          this.cardView = 'true';
        }
       
      }
    }
    this.getCategory();
 
   
  }

  getProducts(){
    this.service.getAllProduct().subscribe(res=>{
      if(res){
        this.items = res;
        this.items.map(dat=>{
          this.category.map(dat1 => {
            if (dat1.id == dat.purchaseCategory) {
              Object.assign(dat, { cateName: dat1.name })
            }
        })
          })
        this.dataSource = new MatTableDataSource(this.items);
      }
      this.loader = false;
    },err=>{
      this.loader = false;
      this.handler.err(err)
    })
  }
  edit(id){
    this.router.navigate(['edit-product/',id]);
  }
  viewChange(id) {
    if (id == 1) { this.cardView = 'true'; }
    else {this.cardView = 'false'; }
  }
  exportAsXLSX(): void {
    this.items.map(res => {
      this.excelData.push({
        ProductName: res.name, PLU: res.plu, Description: res.description,purchaseCategory:res.cateName
      })
    })
    this.excelService.exportAsExcelFile(this.excelData, 'Product');
  }
  deleteProduct(id){
    this.loader=true;
    this.service.deleteProductById(id).subscribe(res=>{
     this.ionViewWillEnter()
     this.loader=false;
      this.handler.res("Deleted successfully")
         },
    err=>{
      this.handler.err(err)
      this.loader=false
    })
  }
  ionViewWillLeave(){
    this.search = "";
  }
  clear(){
    this.search="";
  }

  getCategory(){
    this.service.getAllPurchaseCategory().subscribe((res:any)=>{
      this.category=res;
      this.getProducts();
     })
  }
}
